import { render, staticRenderFns } from "./PageShowSet.vue?vue&type=template&id=08b4f940&scoped=true&"
import script from "./PageShowSet.vue?vue&type=script&lang=js&"
export * from "./PageShowSet.vue?vue&type=script&lang=js&"
import style0 from "./PageShowSet.vue?vue&type=style&index=0&id=08b4f940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4f940",
  null
  
)

component.options.__file = "PageShowSet.vue"
export default component.exports